module.exports = __webpack_public_path__ + "media/images/soar/Compartilhar_encontro-7266bec1a878074c282ff0d656531fb1.gif";